import React, { ReactNode } from 'react';

interface Props {
  /** Hide the CSV hint where no CSV export is available (e.g. vault balance history) */
  hasCsvExport?: boolean;
  /** Custom hint about where the full history can be found (e.g. CSV on another page) */
  csvHint?: ReactNode;
}

/** Warning about PAGINATION_INTERNAL_PAGES_LIMIT */
export default function PaginationNoContentOverWarning({
  hasCsvExport = true,
  csvHint,
}: Props) {
  return (
    <h2
      style={{ padding: '100px 0', textAlign: 'center', lineHeight: 'normal' }}
    >
      We are not able to show more data here.
      {hasCsvExport && (
        <>
          <br />
          {csvHint || 'You can Download CSV to see full history.'}
        </>
      )}
    </h2>
  );
}
